import { Route } from '@angular/router';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';

export const terminListRoutes: Route = {
  path: 'termin',
  loadComponent: () =>
    import('./termin-list.component').then((m) => m.TerminListComponent),
    children: [
        {
          path: 'preview/:id',
          loadComponent: () =>
            import('@backoffice-frontend/news/feature-termin-form').then(
              (m) => m.TerminFormComponent,
            ),
          canDeactivate: [CanDeactivateGuard],
        },
  ],
};
